export const vehicleTransportManifest = {
    id: 'vehicletransport',
    name: 'Vehicle Transport',
    description: 'Professional vehicle transportation for dealerships and auctions — base price includes first 20 miles',
    version: '1.1.0',
    icon: 'Car',
    dependencies: ['maps', 'payments'],
    compatibleVehicles: ['towtruck'],
    allowedRoles: ['customer', 'driver', 'business', 'admin'],
    supportsB2B: true,
    b2bFeatures: {
        multiVehicle: true,
        enclosedTransport: true,
        tradePlateSupport: true,
        collectionDeliveryWindow: true,
        conditionReport: true,
    },
    pricing: {
        configurable: true,
        b2bConfigurable: true,
        fields: [
            { key: "vatRate", type: "percentage", label: "VAT Rate", hint: "UK VAT percentage applied to all charges", format: "percent", defaultValue: 0, min: 0, max: 100 },
            { key: 'basePrice', type: 'money', label: 'Base Price (incl. 20 miles)', hint: 'Base price that includes the first 20 miles (in pence)', format: 'pence', defaultValue: 15000, required: true },
            { key: 'includedMiles', type: 'number', label: 'Miles Included in Base', hint: 'Number of miles covered by the base price', format: 'number', defaultValue: 20, min: 0, required: true },
            { key: 'pricePerMile', type: 'money', label: 'Price per Extra Mile', hint: 'Charge per mile beyond included miles (in pence)', format: 'pence', defaultValue: 200, required: true },
            { key: 'enclosedMultiplier', type: 'percentage', label: 'Enclosed Transport Multiplier', hint: 'Price multiplier for enclosed/covered transport', format: 'percent', defaultValue: 1.5, min: 1, max: 3 },
            { key: 'multiVehicleDiscount', type: 'percentage', label: 'Multi-Vehicle Discount', hint: 'Discount fraction for transporting multiple vehicles (e.g. 0.1 = 10%)', format: 'percent', defaultValue: 0.1, min: 0, max: 0.5 },
            { key: 'minDistance', type: 'number', label: 'Minimum Distance (miles)', hint: 'Shortest trip distance to qualify for this service', format: 'number', defaultValue: 1 },
            { key: 'conditionReportFee', type: 'money', label: 'Condition Report Fee', hint: 'Charge for a vehicle condition report (in pence)', format: 'pence', defaultValue: 2500 },
        ],
    },
    features: {
        requiresInventory: false,
        requiresPropertyType: false,
        allowsMultiDrop: true,
        requiresFloorInfo: false,
        hasAssemblyOption: false,
    },
};
//# sourceMappingURL=manifest.js.map